import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import API from './api';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;

        if (session) {
          const { user } = session;
          
          // Bridging Supabase user to our custom backend
          const response = await API.post('/auth/supabase-login', {
            email: user.email,
            supabaseId: user.id,
            username: user.user_metadata?.full_name?.replace(/\s+/g, '').substring(0, 15) || user.email.split('@')[0]
          });

          if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            
            const userData = {
               username: response.data.username,
               balance: response.data.balance,
               id: response.data.id || response.data.userId,
               totalWagered: response.data.totalWagered || 0,
               referralCode: response.data.referralCode,
               referralEarnings: response.data.referralEarnings || 0,
               referralCount: response.data.referralCount || 0
            };
            
            localStorage.setItem('user', JSON.stringify(userData));
            
            // Sign out of Supabase as we now use our backend session
            await supabase.auth.signOut();
            
            // Successful bridge, redirect to dashboard
            window.location.href = '/dashboard';
          }
        } else {
          // No session found, redirect to login
          navigate('/login');
        }
      } catch (err) {
        console.error('Error during auth callback:', err);
        navigate('/login?error=auth_failed');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#0f0f1e',
      color: '#fff',
      fontFamily: 'Montserrat, sans-serif'
    }}>
      <div className="spinner" style={{
        width: '40px',
        height: '40px',
        border: '4px solid rgba(255, 255, 255, 0.1)',
        borderLeft: '4px solid #ffb703',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '20px'
      }} />
      <p style={{ fontSize: '18px', fontWeight: '500' }}>Finalizing your login...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AuthCallback;
